var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.891,
    height: 23.87,
    viewBox: "0 0 23.891 23.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-vertical-bidirectional-arrow-1916304",
    d: "M199,122.041l5.12-5.12a.853.853,0,0,1,1.206,0l5.12,5.12a.853.853,0,0,1-1.206,1.207l-3.663-3.663V139.71a.853.853,0,0,1-1.706,0V119.585l-3.663,3.663A.853.853,0,0,1,199,122.042Zm-.5,11.945a.853.853,0,0,0-1.206,0l-3.663,3.663V117.525a.853.853,0,0,0-1.706,0V137.65l-3.663-3.663a.853.853,0,0,0-1.206,1.206l5.12,5.12a.853.853,0,0,0,1.206,0l5.12-5.12a.853.853,0,0,0,0-1.206Z",
    transform: "translate(-116.672 210.683) rotate(-90)",
    fill: "#f37320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiarrow);
export default __webpack_public_path__ + "static/media/biarrow.3905ade8aebb36d680e3ced2cc9c0872.svg";
export { ForwardRef as ReactComponent };